angular.module('dnecom')
   .directive('hasErrors', ["$parse", function($parse) {
        return {
            restrict: "A",
            link: function(scope, element, attrs) {
                var createCollection = function(scope, attrs) {
                    var errorCollection = $parse(attrs.hasErrors)(scope);

                    if (typeof errorCollection === 'undefined') {
                        return [];
                    }

                    if (typeof errorCollection.length === 'undefined') {
                        return [errorCollection];
                    }

                    return errorCollection;
                };

                var hasAnyErrors = function(errorCollection) {
                    return _.some(errorCollection, function(errorObject) {
                        if (errorObject 
                            && errorObject.hasOwnProperty('$invalid') 
                            && errorObject.hasOwnProperty('$touched')) {
                            return errorObject.$invalid && errorObject.$touched;
                        }

                        if (typeof errorObject === "boolean") {
                            return errorObject;
                        }

                        return false;
                    });
                };

                scope.$watch(function() {
                    var errorCollection = createCollection(scope, attrs);
                    var hasErrors = hasAnyErrors(errorCollection);

                    if (hasErrors) {
                        element.addClass('has-error');
                    } else {
                        element.removeClass('has-error');
                    }
                        
                    return true;
                });
            }
        };
    }])
;
